import { render, staticRenderFns } from "./CategoryItemsCard.vue?vue&type=template&id=56ac38cf&scoped=true"
import script from "./CategoryItemsCard.vue?vue&type=script&lang=js"
export * from "./CategoryItemsCard.vue?vue&type=script&lang=js"
import style0 from "./CategoryItemsCard.vue?vue&type=style&index=0&id=56ac38cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ac38cf",
  null
  
)

export default component.exports